export default "__VITE_ASSET__ZsfMs6yN__"